export default {
  priceEachWithoutVAT (length, selectedProduct) {
    const price = this.priceEach(length, selectedProduct)
    return price.toFixed(2)
  },
  priceEachWithVAT (length, selectedProduct, vatRate) {
    const price = this.priceEach(length, selectedProduct) * vatRate
    return price.toFixed(2)
  },
  priceWithoutVAT (length, selectedProduct, quantity) {
    const price = this.totalPrice(length, selectedProduct, quantity)
    return price.toFixed(2)
  },
  priceWithVAT (length, selectedProduct, quantity, vatRate) {
    const price = this.totalPrice(length, selectedProduct, quantity) * vatRate
    return price.toFixed(2)
  },
  priceEach (length, selectedProduct) {
    return length && selectedProduct ? (length / 1000) * selectedProduct.price : 0
  },
  totalPrice (length, selectedProduct, quantity) {
    return length && selectedProduct && quantity
      ? (length / 1000) * selectedProduct.price * quantity
      : 0
  }
}
